<template>
  <div>
    <div>
      <img src="../image/top.jpg" style="width: 100%" />
    </div>
    <div class="topstyle">
      <div
        v-for="(item, i) in items"
        :key="i"
        :class="{ bgcolor: i == current }"
      >
        <router-link tag="span" :to="item.route" class="cursor">{{
          item.name
        }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Toolbar",
  props: {
    current: Number,
  },
  data() {
    return {
      items: [
        {
          route: "/",
          name: "首页",
        },
        {
          route: "/xhjs",
          name: "学会介绍",
        },
        {
          route: "/gzdt",
          name: "工作动态",
        },
        {
          route: "/hyfw",
          name: "会员服务",
        },
        {
          route: "/kjcg",
          name: "科技成果",
        },
        {
          route: "/wxsy",
          name: "文献索引",
        },
      ],
    };
  },
};
</script>
<style scoped>
.topstyle {
  height: 30px;
  display: flex;
  justify-content: center;
  background-color: #015293;
  width: 100%;
  text-align: center;
  margin-top: -7px;
}
.bgcolor {
  background-color: #003967;
}
span {
  padding: 0px 50px;
}
.cursor {
  cursor: pointer;
  height: 100%;
  width: 100px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-top: 2px;
}
</style>
 